import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["style", "componentClass", "type", "className", "size", "clsPrefix", "onChange", "onSearch", "onBlur", "showClose", "focusSelect", "prefix", "suffix", "readOnly", "innerClassName", "innerStyle"],
    _excluded2 = ["componentClass", "type", "className", "size", "clsPrefix", "onChange", "onSearch", "onBlur", "style", "readOnly", "maxLength", "showClose", "wrapperClassName", "innerClassName", "innerStyle", "wrapperStyle"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.object.assign.js";
import React, { Component } from "react";
import classnames from "classnames";
import Icon from '../../wui-icon/src';
import PropTypes from "prop-types";
import TextArea from "rc-textarea";
import { WebUI } from "../../wui-core/src/index.js";
import omit from "omit.js";
var propTypes = {
  componentClass: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  type: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "nm", "lg"]),
  onSearch: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onPressEnter: PropTypes.func,
  showClose: PropTypes.bool,
  focusSelect: PropTypes.bool,
  readOnly: PropTypes.bool,
  // 是否兼容ant design模式
  antd: PropTypes.bool,
  debounceDelay: PropTypes.number,
  maxLength: PropTypes.number,
  // style 与 className 默认加载到input组件的外层上 ，如果需要加到input元素上需要使用innerStyle 及 innerClassName
  innerStyle: PropTypes.object,
  innerClassName: PropTypes.string
};
var defaultProps = {
  componentClass: "input",
  clsPrefix: "u-input",
  type: "text",
  size: "md",
  antd: false
};

function fixControlledValue(value) {
  if (typeof value === "undefined" || value === null) {
    return "";
  }

  return value;
}

var cutValue = function cutValue(value, maxLength) {
  if (maxLength && value) {
    value = value.toString().substring(0, maxLength);
  }

  return value;
};

var FormControl = (_dec = WebUI({
  name: "input",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(FormControl, _React$Component);

  var _super = _createSuper(FormControl);

  function FormControl(props) {
    var _this;

    _classCallCheck(this, FormControl);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSearchChange", function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          _this$props$antd = _this$props.antd,
          antd = _this$props$antd === void 0 ? false : _this$props$antd;
      var value = _this.input.value;

      _this.setState({
        value: value,
        showSearch: value == null || value === ""
      });

      if (onChange) {
        antd ? onChange(e) : onChange(value, e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var _this$props2 = _this.props,
          _this$props2$debounce = _this$props2.debounceDelay,
          debounceDelay = _this$props2$debounce === void 0 ? 0 : _this$props2$debounce,
          _this$props2$antd = _this$props2.antd,
          antd = _this$props2$antd === void 0 ? false : _this$props2$antd;
      var now = new Date().getTime();
      if (now - _this.lastScrollCall < debounceDelay) return;
      _this.lastScrollCall = now;
      var onChange = _this.props.onChange;
      var value = _this.input.value || e.target.value; // if (!("value" in this.props)) {

      _this.setState({
        value: value
      }); // }


      if (onChange) {
        antd ? onChange(e) : onChange(value, e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearValue", function () {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          showClose = _this$props3.showClose,
          antd = _this$props3.antd,
          disabled = _this$props3.disabled;
      if (disabled) return;

      _this.setState({
        showSearch: true,
        value: ""
      });

      if (_this.e && _this.e.target) _this.e.target.value = "";

      if (onChange) {
        antd ? onChange(_this.e) : onChange("", _this.e); // onChange("", this.e);
      }

      if (showClose) {
        _this.blurTime && clearTimeout(_this.blurTime);
        _this.blurTime = null;
      }

      _this.input.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var _this$props4 = _this.props,
          onSearch = _this$props4.onSearch,
          type = _this$props4.type,
          onKeyDown = _this$props4.onKeyDown,
          onPressEnter = _this$props4.onPressEnter;

      if (e.keyCode === 13) {
        if (onPressEnter) onPressEnter(e);
        if (type === "search" && onSearch) onSearch(_this.input.value);
      }

      onKeyDown && onKeyDown(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSearch", function (e) {
      var _this$props5 = _this.props,
          onSearch = _this$props5.onSearch,
          disabled = _this$props5.disabled;
      if (onSearch && !disabled) onSearch(_this.input.value);
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      _this.input.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      _this.input.blur();
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      var value = _this.state.value;
      var _this$props6 = _this.props,
          onBlur = _this$props6.onBlur,
          showClose = _this$props6.showClose,
          antd = _this$props6.antd;

      var _e = Object.assign({}, e);

      _this.e = _e;

      _this.setState({
        focused: false
      });

      var callbackData = antd ? e : value;

      if (onBlur) {
        if (showClose && _this.clickClearBtn) {
          _this.clickClearBtn = false;
          onBlur(callbackData, _e, true);
        } else {
          onBlur(callbackData, _e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      var value = _this.state.value;
      var _this$props7 = _this.props,
          onFocus = _this$props7.onFocus,
          antd = _this$props7.antd;

      if (_this.props.focusSelect) {
        _this.input.select();
      }

      var callbackData = antd ? e : value;

      _this.setState({
        focused: true
      });

      if (onFocus) {
        onFocus(callbackData, e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      _this.props.onClick && _this.props.onClick(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onClearBtnMouseDown", function () {
      _this.clickClearBtn = true;
    });

    _defineProperty(_assertThisInitialized(_this), "renderTextArea", function () {});

    _defineProperty(_assertThisInitialized(_this), "renderInput", function () {
      var _this$props8 = _this.props,
          style = _this$props8.style,
          Component = _this$props8.componentClass,
          type = _this$props8.type,
          className = _this$props8.className,
          size = _this$props8.size,
          clsPrefix = _this$props8.clsPrefix,
          onChange = _this$props8.onChange,
          onSearch = _this$props8.onSearch,
          onBlur = _this$props8.onBlur,
          showClose = _this$props8.showClose,
          focusSelect = _this$props8.focusSelect,
          prefix = _this$props8.prefix,
          suffix = _this$props8.suffix,
          readOnly = _this$props8.readOnly,
          innerClassName = _this$props8.innerClassName,
          innerStyle = _this$props8.innerStyle,
          others = _objectWithoutProperties(_this$props8, _excluded);

      var CurrentComp = Component; // input[type="file"] 不应该有类名 .form-control.

      var value = _this.state.value;
      var classes = {};

      if (size) {
        classes["".concat(size)] = true;
      }

      if (type === "textarea" || Component === "textarea") {
        CurrentComp = TextArea;
      }

      var classNames;

      if (type !== "file") {
        classNames = classnames(clsPrefix, classes);
      }

      if (prefix || suffix) classNames += " ".concat(clsPrefix, "-prefix-suffix"); // 加判断，是否有 前后缀，是否加 wrapper

      var focusClassName = _this.state.focused ? "".concat(clsPrefix, "-affix-focus") : '';

      if (showClose || suffix || prefix) {
        if (innerClassName) classNames += " " + innerClassName;
        return /*#__PURE__*/React.createElement("div", {
          className: classnames("".concat(clsPrefix, "-close"), "".concat(clsPrefix, "-affix-wrapper ").concat(clsPrefix, "-affix-wrapper-").concat(size), focusClassName, className, _defineProperty({}, "".concat(clsPrefix, "-affix-wrapper-disabled"), others.disabled)),
          style: style,
          onClick: _this.handleClick
        }, prefix ? /*#__PURE__*/React.createElement("span", {
          className: "".concat(clsPrefix, "-simple-prefix")
        }, prefix) : "", /*#__PURE__*/React.createElement(CurrentComp, _extends({}, omit(others, ["antd", "componentClass", "onClick", "decimalSeparator"]), {
          type: type,
          style: innerStyle,
          ref: function ref(el) {
            return _this.input = el;
          },
          value: fixControlledValue(value),
          onChange: _this.handleChange,
          onBlur: _this.handleBlur,
          onFocus: _this.handleFocus,
          onKeyDown: _this.handleKeyDown,
          readOnly: readOnly // onClick={this.handleClick}
          ,
          className: classnames(classNames),
          maxLength: _this.props.maxLength
        })), showClose && value ? /*#__PURE__*/React.createElement("div", {
          className: "".concat(clsPrefix, "-suffix has-close"),
          onMouseDown: _this.onClearBtnMouseDown,
          onClick: _this.clearValue
        }, /*#__PURE__*/React.createElement(Icon, {
          type: "uf-close-c"
        })) : "", suffix ? /*#__PURE__*/React.createElement("span", {
          className: "".concat(clsPrefix, "-simple-suffix")
        }, suffix) : "");
      } else {
        if (className) classNames += " " + className;
        return /*#__PURE__*/React.createElement(CurrentComp, _extends({
          style: style
        }, omit(others, ["antd", "componentClass", "decimalSeparator"]), {
          type: type,
          ref: function ref(el) {
            return _this.input = el;
          },
          value: fixControlledValue(value),
          onChange: _this.handleChange,
          onBlur: _this.handleBlur,
          readOnly: readOnly,
          onClick: _this.handleClick,
          onFocus: _this.handleFocus,
          onKeyDown: _this.handleKeyDown,
          className: classnames(classNames),
          maxLength: _this.props.maxLength
        }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderSearch", function () {
      var _this$props9 = _this.props,
          Component = _this$props9.componentClass,
          type = _this$props9.type,
          className = _this$props9.className,
          size = _this$props9.size,
          clsPrefix = _this$props9.clsPrefix,
          onChange = _this$props9.onChange,
          onSearch = _this$props9.onSearch,
          onBlur = _this$props9.onBlur,
          style = _this$props9.style,
          readOnly = _this$props9.readOnly,
          maxLength = _this$props9.maxLength,
          showClose = _this$props9.showClose,
          wrapperClassName = _this$props9.wrapperClassName,
          innerClassName = _this$props9.innerClassName,
          innerStyle = _this$props9.innerStyle,
          wrapperStyle = _this$props9.wrapperStyle,
          others = _objectWithoutProperties(_this$props9, _excluded2); // input[type="file"] 不应该有类名 .form-control.


      var value = _this.state.value;
      var classes = {};

      if (size) {
        classes["".concat(size)] = true;
      }

      var focusClassName = _this.state.focused ? "".concat(clsPrefix, "-affix-focus") : '';
      classes["".concat(clsPrefix, "-search")] = true;
      return /*#__PURE__*/React.createElement("div", {
        className: classnames("".concat(clsPrefix, "-search"), "".concat(clsPrefix, "-affix-wrapper"), focusClassName, className, _defineProperty({}, "".concat(clsPrefix, "-affix-wrapper-disabled"), others.disabled)),
        onClick: _this.handleClick,
        style: style
      }, /*#__PURE__*/React.createElement(Component, _extends({
        style: innerStyle
      }, omit(others, ["antd", "componentClass", "onClick", "decimalSeparator"]), {
        type: type,
        ref: function ref(el) {
          return _this.input = el;
        },
        onChange: _this.handleSearchChange,
        value: fixControlledValue(value),
        onKeyDown: _this.handleKeyDown,
        onBlur: _this.handleBlur,
        readOnly: readOnly,
        onFocus: _this.handleFocus,
        className: classnames(clsPrefix, classes, innerClassName),
        maxLength: _this.props.maxLength
      })), showClose && value ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-suffix has-close"),
        onMouseDown: _this.onClearBtnMouseDown,
        onClick: _this.clearValue
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "uf-close-c"
      })) : "", /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-suffix")
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "uf-search",
        onClick: _this.handleSearch
      })));
    });

    var _value = typeof props.value === "undefined" ? cutValue(props.defaultValue, props.maxLength) : cutValue(props.value, props.maxLength);

    _this.state = {
      showSearch: !props.value,
      value: _value,
      focused: false,
      prevValue: props.value
    };
    _this.input = {};
    _this.clickClearBtn = false;
    return _this;
  }

  _createClass(FormControl, [{
    key: "render",
    value: function render() {
      if (this.props.type === "search") {
        return this.renderSearch();
      }

      return this.renderInput();
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, _ref) {
      var prevValue = _ref.prevValue;
      var newState = {
        prevValue: nextProps.value
      };

      if (nextProps.value !== undefined || prevValue !== nextProps.value) {
        newState.value = nextProps.value;
      }

      return newState;
    }
  }]);

  return FormControl;
}(React.Component)) || _class);
FormControl.propTypes = propTypes;
export default FormControl;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-input/src/FormControl.js